import { Card, Col, Row, Table, Tag, Typography } from 'antd'
import { TableProps } from 'antd/lib'

const { Title, Paragraph } = Typography

const DataPrivacyPolicyPage = () => {
  const dataTypesCols: TableProps<any>['columns'] = [
    {
      title: 'FINALITES',
      dataIndex: 'finalites',
      key: 'finalites',
    },
    {
      title: 'DETAILS DES FINALITES POURSUIVIES',
      dataIndex: 'detail',
      key: 'detail',
      render: (text) => <div style={{ whiteSpace: 'pre-line' }}>{text}</div>,
    },
    {
      title: 'BASES LEGALES',
      dataIndex: 'legalBases',
      key: 'legalBases',
    },
  ]

  const dataTypeSource: any[] = [
    {
      key: '1',
      finalites: 'Administration de la Plateforme et des Services',
      detail: `Administration générale de la Plateforme et des Services associés 
  Réalisation d’opérations de maintenance corrective
  Gestion générale de la sécurité de la Plateforme et des Services
  Dépôt de cookies et autres traceurs nécessaires au bon fonctionnement de la Plateforme et des Services 
  Suivi des programmes et réalisation d’analyses sur votre utilisation dans le cadre de nos actions de recherche et développement
  Réalisation de statistiques sur l’utilisation de la Plateforme et des Services.`,
      legalBases:
        'Notre intérêt légitime à fournir une Plateforme fonctionnelle.',
    },
    {
      key: '2',
      finalites: 'Fourniture des Services',
      detail: `Gestion des demandes de création, modification et suppression de Compte 
  Mise à disposition et délivrance des Services aux Utilisateurs 
  Suivi et contrôle de la bonne utilisation des Services 
  Envoi d’informations non-commerciales relatives à la fourniture des Services.`,
      legalBases: `Contractuelle, le Traitement est nécessaire à l’exécution d’un contrat 
  ou de mesures précontractuelles.`,
    },
    {
      key: '3',
      finalites: 'Suivi de la relation client',
      detail: `Traitement des demandes d’information 
  Gestion du précontentieux et du contentieux
  Suivi des demandes.`,
      legalBases: `Notre intérêt légitime à répondre à vos sollicitations 
  et à défendre les intérêts de SUPPLEMENT BACON.`,
    },
    {
      key: '4',
      finalites: 'Gestion de la facturation',
      detail: `Suivi du paiement des Services et de la facturation 
  Gestion des impayés.`,
      legalBases: `Contractuelle, le Traitement est nécessaire à l’exécution d’un contrat 
  ou de mesures précontractuelles.`,
    },
    {
      key: '5',
      finalites: 'Tenue de la comptabilité',
      detail: `Tenue des registres comptables et justificatifs légaux.`,
      legalBases: `Nos obligations légales de conservation des données comptables et fiscales.`,
    },
    {
      key: '6',
      finalites: 'Gestion des demandes d’exercice de droits',
      detail: `Suivi du traitement des demandes
  Réalisation d’opérations sur vos données dans le cadre des demandes adressées.`,
      legalBases: `Nos obligations légales découlant des articles 15 et suivants du RGPD 
  et de la loi Informatique et Libertés.`,
    },
  ]
  const dataTraitementsCols: TableProps<any>['columns'] = [
    {
      title: 'TRAITEMENTS',
      dataIndex: 'traitements',
      key: 'traitements',
    },
    {
      title: 'TYPES DE DONNEES PERSONNELLES COLLECTEES',
      dataIndex: 'typesDonnees',
      key: 'typesDonnees',
      render: (text) => <div style={{ whiteSpace: 'pre-line' }}>{text}</div>,
    },
  ]
  const dataTraitements: any[] = [
    {
      key: '1',
      traitements: 'Administration de la Plateforme et des Services',
      typesDonnees: `Informations associées au Compte (civilité, nom, prénom, adresse de courrier électronique, photo de profil)
  Logs de connexion, données d’utilisation des Services PI (historique des actions sur la Plateforme et les Services)
  Données collectées via des cookies et autres traceurs « techniques »
  Statistiques.`,
    },
    {
      key: '2',
      traitements: 'Fourniture des Services',
      typesDonnees: `Informations associées au Compte (nom, prénom, civilité, adresse de courrier électronique, photo de profil, numéro de téléphone)
  Logs de connexion
  Données relatives à l’utilisation des Services
  Statistiques.`,
    },
    {
      key: '3',
      traitements: 'Suivi de la relation client',
      typesDonnees: `Informations associées à l’intéressé (civilité, nom, prénom, courriel, adresse postale, numéro de téléphone)
  Informations relatives à la demande
  Statistiques.`,
    },
    {
      key: '4',
      traitements: 'Gestion de la facturation',
      typesDonnees: `Informations financières liées à la consommation des Services.
  Données relatives à l’établissement et au règlement des factures : modalités de règlement, remises consenties, reçus, soldes et impayés.`,
    },
    {
      key: '5',
      traitements: 'Tenue de la comptabilité',
      typesDonnees: `Informations comptables et justificatifs légaux.`,
    },
    {
      key: '6',
      traitements: "Gestion des demandes d'exercice de droits",
      typesDonnees: `Données relatives à l’identité de l’utilisateur : civilité, nom, prénoms, adresse, numéro de téléphone, adresses e-mail, numéro d’adhérent, date de naissance. 
  Un justificatif d'identité peut être conservé aux fins de preuve de l'exercice d'un droit d'accès, de rectification ou d'opposition ou pour répondre à une obligation légale.
  Données relatives à votre demande d’exercice des droits.`,
    },
  ]
  const dataConservationCols: TableProps<any>['columns'] = [
    {
      title: 'TRAITEMENTS',
      dataIndex: 'traitements',
      key: 'traitements',
    },
    {
      title: 'PERIODE DE CONSERVATION',
      dataIndex: 'periode',
      key: 'periode',
      render: (text) => <div style={{ whiteSpace: 'pre-line' }}>{text}</div>,
    },
  ]

  const dataConservation: any[] = [
    {
      key: '1',
      traitements: 'Administration de la Plateforme et des Services',
      periode: `Pendant toute la durée de la relation contractuelle puis stockage en archivage intermédiaire 
  pendant la durée de prescription en vigueur, soit cinq (5) ans à des fins de preuve.
  Conservation des logs de connexion et historique des actions pendant une durée n’excédant pas douze (12) mois.`,
    },
    {
      key: '2',
      traitements: 'Fourniture des Services',
      periode: `Pendant toute la durée de la relation contractuelle.`,
    },
    {
      key: '3',
      traitements: 'Suivi de la relation Professionnelle',
      periode: `Pour les réclamations, pendant la durée contractuelle ou en cas de rupture des relations, 
  la durée nécessaire à la clôture de la réclamation.`,
    },
    {
      key: '4',
      traitements: 'Gestion de la facturation',
      periode: `Conservation des informations relatives au paiement (paiement, abonnement, etc.) 
  pendant toute la durée de relation contractuelle`,
    },
    {
      key: '5',
      traitements: 'Tenue de la comptabilité',
      periode: `Sous la forme d’archive intermédiaire : durée légale de conservation (e.g. obligation comptable de 10 ans). 
  La pièce d'identité est conservée le temps nécessaire pour procéder à la vérification 
  de l'identité de la personne concernée.
  Une copie d'un titre d'identité peut être conservée pendant la durée de 6 ans 
  si celle-ci est nécessaire à des fins de preuve ou pour répondre à une obligation légale.`,
    },
    {
      key: '6',
      traitements: "Gestion des demandes d'exercice de droits",
      periode: `Les Données Personnelles relatives à la gestion des demandes de droit sont conservées pour toute la durée 
  nécessaire au Traitement de la demande puis stockage en archivage intermédiaire pendant la durée de prescription pénale applicable, 
  à savoir six ans, en archivage intermédiaire (Art. 8 du code de procédure pénale).`,
    },
  ]
  const dataSubcontractorsCols: TableProps<any>['columns'] = [
    {
      title: 'Identité du Sous-Traitant ultérieur',
      dataIndex: 'sousTraitant',
      key: 'sousTraitant',
    },
    {
      title: 'Traitements de données personnelles sous-traités',
      dataIndex: 'traitements',
      key: 'traitements',
      render: (text) => <div style={{ whiteSpace: 'pre-line' }}>{text}</div>,
    },
    {
      title: 'Localisation du Sous-Traitant ultérieur',
      dataIndex: 'localisation',
      key: 'localisation',
      render: (text) => <div style={{ whiteSpace: 'pre-line' }}>{text}</div>,
    },
  ]
  const dataSubcontractors: any[] = [
    {
      key: '3',
      sousTraitant: 'STRIPE',
      traitements: 'Informations de facturation / données bancaires',
      localisation: 'ETATS UNIS',
      garanties: 'Adhésion au Data Privacy Framework',
    },
    {
      key: '4',
      sousTraitant: 'LARAVEL FORGE',
      traitements: 'Administration serveur backend de la Plateforme',
      localisation: 'ETATS UNIS',
      garanties: '[à compléter]',
    },
    {
      key: '5',
      sousTraitant: 'VERCEL',
      traitements: 'Hébergement du frontend de la Plateforme',
      localisation: 'ETATS UNIS',
      garanties: 'Adhésion au Data Privacy Framework',
    },
    {
      key: '5',
      sousTraitant: 'AWS',
      traitements: 'Envoie et reception des messages',
      localisation: 'ETATS UNIS',
      garanties: 'Adhésion au Data Privacy Framework',
    },
  ]

  return (
    <Card>
      <Row>
        <Col span={24}>
          <Title level={3} style={{ textTransform: 'uppercase' }}>
            Politique de traitement des données
          </Title>
          <Paragraph>
            <Tag color="pink">Version mise à jour au 03/01/2025</Tag>
          </Paragraph>
          <Title level={4} style={{ textTransform: 'uppercase' }}>
            PRÉAMBULE
          </Title>
          <Paragraph>
            Cette Politique de confidentialité s&apos;adresse aux Utilisateurs
            de la solution ECHOW (ci-après la
            &laquo;&nbsp;Plateforme&nbsp;&raquo;), éditée par SUPPLEMENT BACON.
            Ce document a pour objectif de vous informer sur la manière dont
            nous collectons et traitons vos informations personnelles. Le
            respect de la vie privée et des données à caractère personnel est
            pour SUPPLEMENT BACON une priorité, raison pour laquelle nous nous
            engageons à traiter celles-ci dans le plus strict respect de la Loi
            Informatique et Libertés du 6 janvier 1978 (ci-après
            &laquo;&nbsp;loi IEL&nbsp;&raquo;) modifiée et du Règlement (UE)
            général sur la protection des données du 27 avril 2016 (ci-après
            &laquo;&nbsp;RGPD&nbsp;&raquo;). En tout état de cause, nous nous
            engageons à respecter les deux (2) principes essentiels
            suivants&nbsp;:
          </Paragraph>
          <Title level={4}>Article 1. Définitions</Title>
          <Paragraph>
            - Chaque Utilisateur reste maître de ses données à caractère
            personnel
            <br />- Les données sont traitées de manière transparente,
            confidentielle et sécurisée.
          </Paragraph>
          <Title level={4} style={{ textTransform: 'uppercase' }}>
            Article 1. Définitions
          </Title>
          <Paragraph>
            Dans le cadre de cette Politique, les termes, au singulier comme au
            pluriel, auront la signification suivante&nbsp;:
          </Paragraph>
          <Paragraph>
            &ndash; <strong>Éditeur</strong> : la société Supplément Bacon qui
            édite et exploite la Plateforme Echow.
            <br />
            &ndash; <strong>Plateforme</strong> : ensemble du site web, des
            applications, des pages et fonctionnalités mises à disposition par
            l’Éditeur, sous l’appellation « Echow ».
            <br />
            &ndash; <strong>Services</strong> : toute fonctionnalité proposée
            aux Utilisateurs par l’Éditeur sur la Plateforme (mise en relation,
            partage de contenu, messagerie, etc.).
            <br />
            &ndash; <strong>Utilisateur</strong> : toute personne (physique ou
            morale) qui accède à la Plateforme, qu’elle dispose ou non d’un
            compte utilisateur.
            <br />
            &ndash; <strong>Contenu</strong> : tout élément, texte, image,
            vidéo, information ou donnée, publié par l’Éditeur ou par
            l’Utilisateur sur la Plateforme. &laquo;
            <br />
            &ndash;{' '}
            <strong>
              Donnée à caractère personnel ou Donnée personnelle :
            </strong>
            désigne toute information se rapportant à une personne physique
            identifiée ou identifiable, directement ou indirectement, notamment
            par référence à un identifiant, tel qu’un nom, un numéro
            d’identification, des données de localisation, un identifiant en
            ligne, ou à un ou plusieurs éléments spécifiques propres à son
            identité physique, physiologique, génétique, psychique, économique,
            culturelle ou sociale.
          </Paragraph>
          <Title level={4} style={{ textTransform: 'uppercase' }}>
            Article 2. Identité du responsable de traitement
          </Title>
          <Paragraph>
            Dans le cadre de la fourniture des différents Services, SUPPLEMENT
            BACON jouera auprès de vous le rôle de &laquo;&nbsp;Responsable de
            traitement&nbsp;&raquo; au sens du RGPD.
          </Paragraph>
          <Paragraph>
            <em>Rappel légal&nbsp;:</em>
            <br />
            Le responsable du traitement est, au sens de la loi Informatique et
            Libertés et du RGPD, la personne qui détermine les moyens et les
            finalités du traitement. Lorsque deux responsables du traitement ou
            plus déterminent conjointement les finalités et les moyens du
            traitement, ils sont les responsables conjoints du traitement (ou
            co-responsables). Le sous-traitant est une personne traitant des
            données à caractère personnel pour le compte du responsable du
            traitement, il agit sous l&apos;autorité du responsable du
            traitement et sur instruction de celui-ci.
          </Paragraph>
          <Title level={4} style={{ textTransform: 'uppercase' }}>
            Article 3. Coordonnées de notre Délégué à la Protection des Données
          </Title>
          <Paragraph>
            Notre Délégué à la Protection des Données (ci-après
            &laquo;&nbsp;DPO&nbsp;&raquo;) est là pour répondre à toutes les
            demandes, y compris d’exercice de droits, relatives à vos données à
            caractère personnel.
            <br />
            Vous pouvez le joindre&nbsp;:
            <br />- Par courriel à&nbsp;: dpo@echow.app
          </Paragraph>
          <Paragraph>
            <em>En savoir plus</em>
            <br />
            Le Délégué à la Protection des Données a pour mission d’informer, de
            conseiller et de contrôler la conformité de SUPPLEMENT BACON dans la
            réalisation des opérations de traitements effectuées. Conformément à
            la réglementation en matière de protection des données, le DPO fait
            office de point de contact&nbsp;:
          </Paragraph>
          <Paragraph>
            - Vis-à-vis des personnes concernées pour tout sujet relatif aux
            traitements de données effectués par SUPPLEMENT BACON ou l’exercice
            de vos droits
            <br />
            - Vis-à-vis de la CNIL dans le cadre de sa mission de coopération.
            Le DPO peut également prendre contact avec cette autorité pour
            solliciter un avis ou une consultation préalable sur tous les sujets
            concernant la protection des données à caractère personnel
            <br />- Vis-à-vis des autres DPO nommés par les organismes
            sous-traitants ou responsables de traitements participants.
          </Paragraph>
          <Title level={4} style={{ textTransform: 'uppercase' }}>
            Article 4. Comment collectons-nous vos données&nbsp;?
          </Title>
          <Paragraph>
            Par principe, l’ensemble des données à caractère personnel vous
            concernant sont collectées directement auprès de vous.
            <br />
            Par exemple lors de la création d’un Compte sur la Plateforme ou
            lors d’échanges avec SUPPLEMENT BACON (demande de contact,
            courriers, etc.)
            <br />
          </Paragraph>
          <Title level={4} style={{ textTransform: 'uppercase' }}>
            Article 5. Quelles sont les finalités et bases légales des
            traitements que nous mobilisons&nbsp;?
          </Title>
          <Paragraph>
            Nous collectons uniquement les données personnelles nécessaires pour
            des finalités explicites et déterminées ci-dessous&nbsp;:
          </Paragraph>
          <Table columns={dataTypesCols} dataSource={dataTypeSource} />
          <Paragraph>
            Lorsque la base légale mobilisée est la poursuite d’un intérêt
            légitime, vous avez la possibilité, sur simple demande, d’obtenir
            des informations complémentaires relatives à la mise en balance des
            intérêts.
          </Paragraph>
          <Title level={4} style={{ textTransform: 'uppercase' }}>
            Article 6. Quelles sont les types de données collectées&nbsp;?
          </Title>
          <Paragraph>
            Le caractère obligatoire ou facultatif des Données Personnelles
            collectées et les éventuelles conséquences d&apos;un défaut de
            réponse sont indiqués lors des différents contacts avec les
            Utilisateurs.
            <br />
            Vous pouvez consulter le détail des Données Personnelles que nous
            sommes susceptibles de collecter ci-après&nbsp;:
          </Paragraph>
          <Table columns={dataTraitementsCols} dataSource={dataTraitements} />
          <Paragraph>
            Le détail sur les informations fournies ci-après n’a pas vocation à
            être exhaustif et vise avant tout à vous informer sur les catégories
            de Données Personnelles que SUPPLEMENT BACON est susceptible de
            traiter.
            <br />
            En tout état de cause, SUPPLEMENT BACON s’engage à traiter
            l’ensemble des Données collectées de manière conforme au RGPD et à
            la Loi Informatique et Libertés.
            <br />
            Lorsque la collecte de ces informations revêt un caractère
            obligatoire, nous vous l’indiquerons par une mention du type
            &laquo;&nbsp;*&nbsp;&raquo; au moment de la collecte.
          </Paragraph>
          <Title level={4} style={{ textTransform: 'uppercase' }}>
            Article 7. Qui peut accéder à vos Données Personnelles&nbsp;?
          </Title>
          <Paragraph>
            Dans la limite de leurs attributions respectives et pour les
            finalités rappelées ci-dessus, les principales personnes qui seront
            susceptibles d’avoir accès à vos Données sont les suivantes&nbsp;:
          </Paragraph>
          <Paragraph>
            - Le personnel habilité de SUPPLEMENT BACON
            <br />
            - Les autres Utilisateurs rattachés au même compte
            <br />
            - Le cas échéant, le personnel habilité des sous-traitants de
            SUPPLEMENT BACON&nbsp;: prestataire d’hébergement de la Plateforme…
            <br />
            - Le cas échéant, les tiers intervenant dans les opérations de
            facturation&nbsp;: Banques, Prestataire de Services de Paiements…
            <br />
            - Le cas échéant, les juridictions concernées, médiateurs,
            experts-comptables, commissaires aux comptes, avocats, commissaires
            de justice, sociétés de recouvrement de créances, autorités de
            police ou de gendarmerie en cas de vol ou de réquisition judiciaire
            <br />- Le cas échéant, les tiers susceptibles de déposer des
            cookies &laquo;&nbsp;commerciaux&nbsp;&raquo; sur vos terminaux
            (ordinateurs, tablettes, smartphones…) lorsque vous y consentez.
          </Paragraph>
          <Paragraph>
            Vos Données Personnelles ne sont communiquées, échangées, vendues ou
            louées à aucune autre personne que celles mentionnées ci-dessus sans
            votre consentement exprès, préalable et conformément aux
            dispositions légales et réglementaires applicables.
          </Paragraph>
          <Title level={4} style={{ textTransform: 'uppercase' }}>
            Article 8. Combien de temps conserve-t-on vos données
            personnelles&nbsp;?
          </Title>
          <Paragraph>
            Nous conservons vos Données Personnelles uniquement le temps
            nécessaire pour les finalités poursuivies, telles que synthétisées
            dans le tableau ci-après&nbsp;:
          </Paragraph>
          <Table columns={dataConservationCols} dataSource={dataConservation} />
          <Title level={4} style={{ textTransform: 'uppercase' }}>
            Article 9. Quels sont vos droits&nbsp;?
          </Title>
          <Paragraph>
            Conformément à la loi IEL et au RGPD, vous disposez de plusieurs
            droits relatifs à vos Données Personnelles&nbsp;:
          </Paragraph>
          <Paragraph>
            -{' '}
            <strong>
              Droit de retirer votre consentement à tout moment&nbsp;:
            </strong>{' '}
            pour les finalités fondées sur le consentement, l’article 7 du RGPD
            dispose que vous pouvez retirer votre consentement à tout moment. Ce
            retrait ne remettra pas en cause la légalité du Traitement effectué
            avant le retrait (article 13-2c RGPD)
            <br />-{' '}
            <strong>
              Droit de définir le sort de vos Données personnelles après votre
              mort
            </strong>{' '}
            et de choisir que nous communiquions (ou non) vos Données
            personnelles à un tiers que vous aurez préalablement désigné
            (article 85 LIL).
            <br />- <strong>Droit d’accès&nbsp;:</strong> vous avez le droit
            d’accéder à tout moment à l’ensemble de vos Données Personnelles, en
            vertu de l’article 15 RGPD
            <br />- <strong>Droit de rectification&nbsp;:</strong> vous avez le
            droit de rectifier à tout moment vos Données personnelles inexactes,
            incomplètes ou obsolètes conformément à l’article 16 du RGPD
            <br />- <strong>Droit à l’effacement&nbsp;:</strong> vous avez le
            droit d’exiger que vos Données personnelles soient effacées et d’en
            interdire toute collecte future pour les motifs énoncés à l’article
            17 du RGPD, à savoir lorsqu’elles sont inexactes, incomplètes,
            équivoques, périmées, ou dont la collecte, l&apos;utilisation, la
            communication ou la conservation est interdite (en savoir plus)
            <br />- <strong>
              Droit à la limitation du traitement&nbsp;:
            </strong>{' '}
            vous avez le droit de nous demander de geler temporairement
            l’utilisation de certaines de vos données, sous conditions prévues
            (article 18 du RGPD)
            <br />- <strong>Droit d’opposition&nbsp;:</strong> en vertu de
            l’article 21 RGPD, vous avez le droit de vous opposer. Notez
            toutefois que nous pourrons maintenir leur Traitement malgré cette
            opposition, pour des motifs légitimes ou la défense de droits en
            justice.&nbsp;
            <br />- <strong>Droit à la portabilité&nbsp;:</strong> selon
            certaines conditions précisées à l’article 20 du RGPD, vous avez le
            droit de recevoir les Données personnelles que vous nous avez
            fournies dans un format standard lisible par machine et d’exiger
            leur transfert au destinataire de votre choix.
          </Paragraph>
          <Paragraph>
            Ces droits peuvent être exercés en contactant notre DPO&nbsp;:
            <br />
            - Courrier électronique à l’adresse&nbsp;: dpo@echow.app
            <br />
            - Voie postale à l’adresse&nbsp;: SUPPLEMENT BACON – 7 rue Narcisse
            Diaz, 75016 Paris.
            <br />
            Vous disposez également de la possibilité d’introduire une
            réclamation auprès d’une autorité de contrôle compétente.
            <br />A date, SUPPLEMENT BACON ne réalise pas de prise de décision
            automatisée pouvant entraîner des effets juridiques à votre égard,
            ou vous affectant de manière significative.
          </Paragraph>
          <Title level={4} style={{ textTransform: 'uppercase' }}>
            Article 10. Qu’en est-il des cookies et autres
            &laquo;&nbsp;traceurs&nbsp;&raquo;&nbsp;?
          </Title>
          <Paragraph>
            SUPPLEMENT BACON fait usage sur sa Plateforme de Données de
            connexion (date, heure, adresse Internet, protocole de l’ordinateur
            du visiteur, page consultée) et de cookies (petits fichiers
            enregistrés sur votre ordinateur) permettant de vous identifier, de
            mémoriser vos consultations, et de bénéficier de mesures et
            statistiques d’audience de la Plateforme notamment relatives aux
            pages consultées. En fonction des finalités, les Utilisateurs
            peuvent consentir, refuser ou choisir le dépôt de certains types de
            cookies sur leurs terminaux.
          </Paragraph>
          <Title level={4} style={{ textTransform: 'uppercase' }}>
            Article 11. Vos Données Personnelles sont-elles transférées en
            dehors de l’Union européenne&nbsp;?
          </Title>
          <Paragraph>
            Dans le cadre de notre activité, nous pouvons être amenés à réaliser
            des transferts de vos Données en dehors de l’Espace Economique
            Européen&nbsp;:
          </Paragraph>
          <Table
            columns={dataSubcontractorsCols}
            dataSource={dataSubcontractors}
          />
          <Title level={4} style={{ textTransform: 'uppercase' }}>
            Article 12. Quelles mesures de sécurité sont mises en œuvre&nbsp;?
          </Title>
          <Paragraph>
            Nous mettons en œuvre toutes les mesures techniques et
            organisationnelles nécessaires afin de nous assurer de la sécurité
            de nos traitements de données à caractère personnel et de la
            confidentialité des données que nous collectons. A ce titre, nous
            prenons toutes les précautions utiles, au regard de la nature des
            données et des risques présentés par les traitements pour en
            préserver la sécurité et, notamment, empêcher que les données soient
            déformées, endommagées, ou que des tiers non autorisés y aient accès
            (protection physique des locaux, procédés d’authentification des
            personnes accédant aux données avec accès personnel et sécurisé via
            des identifiants et mots de passe confidentiels, journalisation et
            traçabilité des connexions, etc.).
          </Paragraph>
        </Col>
      </Row>
    </Card>
  )
}

export default DataPrivacyPolicyPage
